/**
 * Version of the onboarding flow that produced an analytics event.
 *
 * - `"v2.0"` — the flow-engine-based onboarding flow. Introduces the
 *   intent-selection question, intent-customized education screens, and a
 *   mobile-only post-auth notification permission step.
 * - `"v3.0"` — the signup-first flow (FFGA designs): profile + intent capture
 *   moves post-auth, with an insurance-selection step. Reported both by the
 *   partner-invite (FFGA) entry and the flag-driven general-user variant.
 *
 * Retired versions must leave this list: a stale flag value only counts as a
 * flow version while it's here, and an unknown value falls back to the default.
 */
export const ONBOARDING_VERSIONS = ["v2.0", "v3.0"] as const;

export type OnboardingFlowVersion = (typeof ONBOARDING_VERSIONS)[number];
